import React from "react";
import { Howl } from "howler";
import { toast } from "react-toastify";
import BookingToast from "./BookingToast";

const BookingToaster = ({ data, eventType, history, closeToast }) => {
  try {
    let soundSrc;
    let toastType;
    let toastMessage;
    let autoClose = false;
    let progressClassName = "";
    let className = "";
    let closeButton = true;
    let closeOnClick = true;

    if (eventType === "booking-create") {
      soundSrc = [require("../assets/audios/booking-confirmation.mp3")];
      toastType = "info";
      toastMessage = data.message;
      autoClose = true;
      closeOnClick = false;
      progressClassName = "custom-progress-bar-booking";
    } else if (eventType === "booking-cancel") {
      soundSrc = [require("../assets/audios/booking-cancel.mp3")];
      toastType = "info";
      toastMessage = data.message;
      autoClose = true;
      closeOnClick = false;
      progressClassName = "custom-progress-bar-error";
    } else if (eventType === "booking-update") {
      soundSrc = [require("../assets/audios/booking-confirmation.mp3")];
      toastType = "info";
      toastMessage = (
        <BookingToast
          {...data}
          closeOnClick={closeOnClick}
          closeToast={closeToast}
          history={history}
        />
      );
      progressClassName = "custom-progress-bar-update";
      className = "custom-toast";
      closeButton = false;
      closeOnClick = false;
    }

    const successSound = new Howl({
      src: soundSrc,
      autoplay: true,
    });
    successSound.play();
    console.log({ asasasas: data });

    // Display toast using custom function
    toast(toastMessage, {
      type: toastType,
      autoClose,
      progressClassName,
      className,
      closeButton,
      closeOnClick,
    });

    // Return null or any other component if needed
    return null;
  } catch (error) {
    console.error("Error playing audio or displaying toast:", error);
    return null; // Return null or any other component if needed
  }
};

export default BookingToaster;
